const actions = {

  MAIL_READ_BEGIN: 'MAIL_READ_BEGIN',
  MAIL_READ_SUCCESS: 'MAIL_READ_SUCCESS',
  MAIL_READ_ERR: 'MAIL_READ_ERR',

  MAIL_ADD_BEGIN: 'MAIL_ADD_BEGIN',
  MAIL_ADD_SUCCESS: 'MAIL_ADD_SUCCESS',
  MAIL_ADD_ERR: 'MAIL_ADD_ERR',

  GET_MAIL_READ_BEGIN: 'GET_MAIL_READ_BEGIN',
  GET_MAIL_READ_SUCCESS: 'GET_MAIL_READ_SUCCESS',
  GET_MAIL_READ_ERR: 'GET_MAIL_READ_ERR',

  GET_LEAVES_READ_BEGIN: 'GET_LEAVES_READ_BEGIN',
  GET_LEAVES_READ_SUCCESS: 'GET_LEAVES_READ_SUCCESS',
  GET_LEAVES_READ_ERR: 'GET_LEAVES_READ_ERR',


  GET_LEAVESREQUEST_READ_BEGIN: 'GET_LEAVESREQUEST_READ_BEGIN',
  GET_LEAVESREQUEST_READ_SUCCESS: 'GET_LEAVESREQUEST_READ_SUCCESS',
  GET_LEAVESREQUEST_READ_ERR: 'GET_LEAVESREQUEST_READ_ERR',

  GET_LEAVESDATA_READ_BEGIN: 'GET_LEAVESDATA_READ_BEGIN',
  GET_LEAVESDATA_READ_SUCCESS: 'GET_LEAVESDATA_READ_SUCCESS',
  GET_LEAVESDATA_READ_ERR: 'GET_LEAVESDATA_READ_ERR',


  LEAVEUPDATE_UPDATE_BEGIN: 'LEAVEUPDATE_UPDATE_BEGIN',
  LEAVEUPDATE_UPDATE_SUCCESS: 'LEAVEUPDATE_UPDATE_SUCCESS',
  LEAVEUPDATE_UPDATE_ERR: 'LEAVEUPDATE_UPDATE_ERR',


  LeaveUpdateUpdateBegin: () => {
    return {
      type: actions.LEAVEUPDATE_UPDATE_BEGIN,
    };
  },

  LeaveUpdateUpdateSuccess: (data) => {
    return {
      type: actions.LEAVEUPDATE_UPDATE_SUCCESS,
      data,
    };
  },

  LeaveUpdateUpdateErr: (err) => {
    return {
      type: actions.LEAVEUPDATE_UPDATE_ERR,
      err,
    };
  },

  getLeavesRequestReadBegin: () => {
    return {
      type: actions.GET_LEAVESREQUEST_READ_BEGIN,
    };
  },

  getLeavesRequestReadSuccess: (data) => {
    return {
      type: actions.GET_LEAVESREQUEST_READ_SUCCESS,
      data,
    };
  },

  getLeavesRequestReadErr: (err) => {
    return {
      type: actions.GET_LEAVESREQUEST_READ_ERR,
      err,
    };
  },



  getLeavesDataReadBegin: () => {
    return {
      type: actions.GET_LEAVESDATA_READ_BEGIN,
    };
  },

  getLeavesDataReadSuccess: (data) => {
    return {
      type: actions.GET_LEAVESDATA_READ_SUCCESS,
      data,
    };
  },

  getLeavesDataReadErr: (err) => {
    return {
      type: actions.GET_LEAVESDATA_READ_ERR,
      err,
    };
  },



  mailReadBegin: () => {
    return {
      type: actions.MAIL_READ_BEGIN,
    };
  },

  mailReadSuccess: (data) => {
    return {
      type: actions.MAIL_READ_SUCCESS,
      data,
    };
  },

  mailReadErr: (err) => {
    return {
      type: actions.MAIL_READ_ERR,
      err,
    };
  },

  mailAddBegin: () => {
    return {
      type: actions.MAIL_ADD_BEGIN,
    };
  },

  mailAddSuccess: (data) => {
    return {
      type: actions.MAIL_ADD_SUCCESS,
      data,
    };
  },

  mailAddErr: (err) => {
    return {
      type: actions.MAIL_ADD_ERR,
      err,
    };
  },



  getmailReadBegin: () => {
    return {
      type: actions.GET_MAIL_READ_BEGIN,
    };
  },

  getmailReadSuccess: (data) => {
    return {
      type: actions.GET_MAIL_READ_SUCCESS,
      data,
    };
  },

  getmailReadErr: (err) => {
    return {
      type: actions.GET_MAIL_READ_ERR,
      err,
    };
  },



  getLeavesReadBegin: () => {
    return {
      type: actions.GET_LEAVES_READ_BEGIN,
    };
  },

  getLeavesReadSuccess: (data) => {
    return {
      type: actions.GET_LEAVES_READ_SUCCESS,
      data,
    };
  },

  getLeavesReadErr: (err) => {
    return {
      type: actions.GET_LEAVES_READ_ERR,
      err,
    };
  },

};

export default actions;
